import React from "react";
import {Heatmap} from "@mui/x-charts-pro";
import CCMuiChart from "./CCMuiChart";

class CCHeatmap extends CCMuiChart {
    static ATTR_MAP: [string, string][] = [
        ["Colors", "colors"],
        ["Dataset", "dataset"],
        ["DisableAxisListener", "disableAxisListener"],
        ["Grid", "grid"],
        ["Height", "height"],
        ["HiddenItems", "hiddenItems"],
        ["HideLegend", "hideLegend"],
        ["HighlightedItem", "highlightedItem"],
        ["Id", "id"],
        ["LoadingText", "loadingText"],
        ["Margin", "margin"],
        ["onHiddenItemsChange", "onHiddenItemsChange"],
        ["onHighlightChange", "onHighlightChange"],
        ["onItemClick", "onItemClick"],
        ["ShowToolbar", "showToolbar"],
        ["SkipAnimation", "skipAnimation"],
        ["SlotProps", "slotProps"],
        ["Slots", "slots"],
        ["Width", "width"],
        ["ZoomData", "zoomData"],
        ["ZoomInteractionConfig", "zoomInteractionConfig"],
    ];

    renderChart(chartProps: any): React.ReactNode {
        return <Heatmap {...chartProps} sx={this.props.sx} />;
    }
}

export default CCHeatmap;
